<template>
  <button
    v-tippy="{ content: tooltip ? tooltip : null, placement: 'top', delay }"
    type="button"
    data-testid="button-card-label"
    class="flex flex-1 rounded-lg border-2"
    :class="[
      active && !disabled ? 'border-zblue-60' : 'border-gray-30',
      disabled && 'cursor-not-allowed',
      smallPadding ? 'p-3' : 'p-4',
      isComingSoon ? 'bg-gray-20' : 'bg-white',
      !disabled ? 'hover:bg-zblue-10 hover:border-zblue-60' : '',
    ]"
  >
    <div class="flex flex-row items-start gap-2">
      <div class="w-full">
        <div
          class="mb-1 flex min-h-6 items-center gap-2 text-sm font-medium"
          :class="disabled ? 'text-gray-50' : 'text-gray-80'"
        >
          {{ title }}
          <ui-tag v-if="isComingSoon" theme="blue">{{ $t('settings.coming_soon') }}</ui-tag>
        </div>
        <div
          data-testid="button-card-description"
          class="flex text-left text-xs font-normal"
          :class="disabled ? 'text-gray-50' : 'text-gray-60'"
        >
          {{ description }}
        </div>
        <div v-if="$slots.additionalContent" class="mt-4 text-sm">
          <slot name="additionalContent" />
        </div>
      </div>
    </div>
  </button>
</template>

<script lang="ts" setup>
import { UiTag } from '@klausapp/ui-kit'
import { delay } from '@/components/Tippy'

defineProps<{
  title: string
  description: string
  tooltip?: string
  active?: boolean
  disabled?: boolean
  isComingSoon?: boolean
  smallPadding?: boolean
}>()
</script>
